const API = {
    GetFullOrders: `/wxordercenter/H5OrderListAPI/GetH5FullOrders`,  // 切走
    GetSecOrders: `/ordercenter/OrderListAPI/GetH5SecOrders`,  //不用了
    ServiceOrderDelete: `/wxorderoper/orderlistapi/deleteh5order`,
    ServiceOrderCancel: `/wxorderoper/orderlistapi/cancelh5order`,
    CancelReason: `/wxorderoper/orderlistapi/geth5cancelreason`,
    GetFilterProducts: `/wxordercenter/OrderListAPI/GetFilterProducts`,
    GetRelOrders: `/wxorderoper/orderlistapi/getrelorders`,
    GetFilterPageProducts: `/wxordercenter/OrderListAPI/GetFilterPageProducts`, // 切走
    Hasten: `/wxorderoper/orderlistapi/geth5orderhasten`,
    GetPageSetting: `/wxordercenter/home/GetThrottleParams`, // 切走
    GetWxConfig: `/wxordercenter/home/GetWXApiConfig`,
    GetHistoryOrderList: '/wxocbdapi/his/getlist', // 历史订单
    RemoveHisOrder: '/wxocbdapi/his/del', // 删除历史订单
    HisConfig: '/wxocbdapi/his/getconfig', // 历史订单页面配置。
    deleteOrder: '/wxorderoper/orderlistapi/deletehistoryorder', // 历史订单页面配置。
}
var outPut = API
function getOSVersion() { // 获取操作系统版本
    var OSVision = '';
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //Android
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    try {
        if (isAndroid) {
            OSVision = navigator.userAgent.split(';')[1].match(/\d+\.\d+/g)[0];
        }
        if (isIOS) {
            OSVision = navigator.userAgent.split(';')[1].match(/(\d+)_(\d+)_?(\d+)?/)[0];
        }
    } catch (e) { }

    return OSVision;
}
function getOS() { // 获取当前操作系统
    var os;
    if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1) {
        os = 'Android';
    } else if (navigator.userAgent.indexOf('iPhone') > -1) {
        os = 'iOS';
    } else if (navigator.userAgent.indexOf('Windows Phone') > -1) {
        os = 'WP';
    } else {
        os = 'Others';
    }
    return os;
}

export const api = outPut
export const miniAppVer = '0.0.8'
export const enterType = 1
export const devType = getOS() + ' ' + getOSVersion();

export const miniOrderVer = "200211"


// WEBPACK FOOTER //
// ./src/util/api.js